import { useEffect, useState } from 'react';

export const useMiningLogs = (isMining: boolean) => {
  const [logs, setLogs] = useState<string[]>([]);
  const [totalProfit, setTotalProfit] = useState(() => {
    const saved = localStorage.getItem('totalMined');
    return saved ? parseFloat(saved) : 0;
  });

  useEffect(() => {
    if (!isMining) return;

    const interval = setInterval(() => {
      const profit = parseFloat((Math.random() * 0.002 + 0.0003).toFixed(4));
      const timestamp = new Date().toLocaleTimeString();
      const entry = `[${timestamp}] Mined block: +${profit} SOL`;

      setLogs((prev) => [entry, ...prev].slice(0, 1000));
      setTotalProfit((prev) => {
        const updated = prev + profit;
        localStorage.setItem('totalMined', updated.toFixed(4));
        return updated;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [isMining]);

  return { logs, setLogs, totalProfit, setTotalProfit };
};
